export const LOG_SCHEMA_VERSION = 1;

export const LOG_EVENT_TYPE = Object.freeze({
    VIEW: 'view',
    OPERATION: 'operation',
    SERVICE: 'service',
    PERFORMANCE: 'performance',
});

/**
 * Construct the stable structured-event envelope.
 * Event-specific builders remain responsible for attributes and PII safety.
 *
 * @param {Object} input
 * @param {string} input.eventType
 * @param {string} input.codeLocation
 * @param {string} input.methodName
 * @param {string} input.level
 * @param {string} input.message
 * @param {string} input.outcome
 * @param {string} [input.transactionId]
 * @param {Object} [input.attributes]
 * @returns {Object}
 */
export const createLogEvent = ({
    eventType,
    codeLocation,
    methodName,
    level,
    message,
    outcome,
    transactionId,
    attributes = {},
}) => ({
    schema_version: LOG_SCHEMA_VERSION,
    event_type: eventType,
    code_location: codeLocation,
    method_name: methodName,
    level,
    message,
    outcome,
    ...(transactionId ? { transaction_id: transactionId } : {}),
    attributes,
});
